import { render, staticRenderFns } from "./suitch-seismograph.vue?vue&type=template&id=40ec8b58&"
import script from "./suitch-seismograph.vue?vue&type=script&lang=js&"
export * from "./suitch-seismograph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports